import React, { useEffect, useState } from "react";
import axios from "axios";
import { Spin, Alert } from "antd";

function PlanTrip() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await axios.get("http://93.127.203.113:5005/services"); // 🔥 Fetch data from API
      setServices(response.data);
    } catch (error) {
      setError("Failed to load services. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="services-section">
        <div className="container">
          <div className="services-container">
            <div className="services-container__title">
              <h3>Our Services</h3>
              <h2>What We Offer</h2>
            </div>

            {loading ? (
              <div className="loading-container">
                <Spin size="large" />
              </div>
            ) : error ? (
              <Alert message={error} type="error" showIcon />
            ) : (
              <div className="services-container__boxes">
                {services.map((service) => (
                  <div key={service.id} className="services-container__boxes__box">
                    <img
                      src={`http://93.127.203.113:5005${service.image}`}
                      alt={service.title}
                      className="icon-img"
                    />
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* 🌟 Styles (Same as before) */}
      <style jsx>{`
        .services-section {
          background-color: #f8f9fa;
          padding: 80px 0;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .services-container {
          width: 100%;
          margin: 0 auto;
          padding: 80px;
          border-radius: 18px;
          background: linear-gradient(135deg, #fff, rgba(255, 255, 255, 0));
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        }

        .services-container__title {
          text-align: center;
          margin-bottom: 40px;
        }

        .services-container__title h3 {
          font-size: 2.4rem;
          font-weight: 600;
          color: #0c8c49;
          text-transform: uppercase;
          letter-spacing: 2px;
          margin-bottom: 10px;
        }

        .services-container__title h2 {
          font-size: 3.5rem;
          font-weight: bold;
          color: #333;
          line-height: 1.3;
        }

        .services-container__boxes {
          display: flex;
          justify-content: space-between;
          gap: 40px;
          flex-wrap: wrap;
        }

        .services-container__boxes__box {
          background: white;
          border-radius: 10px;
          padding: 30px;
          text-align: center;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          width: 30%;
        }

        .services-container__boxes__box:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
        }

        .icon-img {
          width: 60px;
          margin-bottom: 20px;
          transition: transform 0.3s ease;
        }

        .services-container__boxes__box:hover .icon-img {
          transform: rotate(15deg);
        }

        .services-container__boxes__box h3 {
          font-size: 2.5rem;
          font-weight: bold;
          margin-bottom: 15px;
        }

        .services-container__boxes__box p {
          font-size: 1.6rem;
          color: #555;
          line-height: 1.6;
        }

        .loading-container {
          text-align: center;
          margin-top: 50px;
        }

        @media (max-width: 768px) {
          .services-container__boxes__box {
            width: 100%;
            margin-bottom: 30px;
          }

          .services-container__title h2 {
            font-size: 2.5rem;
          }

          .services-container__boxes {
            flex-direction: column;
            align-items: center;
          }
        }
      `}</style>
    </>
  );
}

export default PlanTrip;
